import { createRoot } from "react-dom/client";
import { App } from "core/components/App";

createRoot(document.getElementById("app")).render(<App />);
